import { render } from "./HeaderInc.vue?vue&type=template&id=4b8db249"
import script from "./HeaderInc.vue?vue&type=script&lang=js"
export * from "./HeaderInc.vue?vue&type=script&lang=js"

import "./HeaderInc.vue?vue&type=style&index=0&id=4b8db249&lang=css"

import exportComponent from "E:\\claude\\match\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__